import { AppScreenOrientationService } from '../app-screen-orientation/app-screen-orientation.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Injectable, inject } from '@angular/core';
import { timeout } from '../../util/timeout';

@Injectable({ providedIn: 'root' })
export class SplashScreenService {
  private appScreenOrientationService = inject(AppScreenOrientationService);


  private splashScreenVisible = true;
  public async hide(): Promise<void> {
    if (this.splashScreenVisible) {
      await timeout(100);
      console.log('SplashScreenService: hide');
      await SplashScreen.hide({ fadeOutDuration: 100 });
      await this.appScreenOrientationService.init('SplashScreenService');
      this.splashScreenVisible = false;
    }
  }
}
